<header class="header-style5" id="header-section1">
    <!-- nav -->
    <nav class="navbar navbar-expand-lg w-100 bg-servios no-margin alt-font shrink-header light-header shrink-nav">
        <div class="container ">
            <div class="row display-block w-100">
                <div class="col-md-2 col-sm-4 col-6">
                    <div class="logo xs-padding-nineteen-left">
                        <a href="#home" class="inner-link"><img alt=""
                                src="assets/image/Logo-Servios_vertical_blanco.png"></a>
                    </div>
                </div>
                <div class="col-md-10 col-sm-8 col-6 position-inherit xs-no-padding-left">
                    <a href="#" data-target="#bs-example-navbar-collapse-1" data-toggle="collapse"
                        class="navbar-toggle collapsed d-none sm-display-block sm-display-flex justify-content-end">
                        <h3 class="p-1 text-white"><i class="fas fa-bars"></i></h3>
                    </a>
                    <div id="bs-example-navbar-collapse-1"
                        class="collapse navbar-collapse clear-both sm-position-fixed">
                        <ul class="nav navbar-nav navigation-menu justify-content-end blog text-white">
                            <li><a class="inner-link" (click)="goTo('/')">INICIO</a></li>
                            <li><a class="inner-link" (click)="goTo('/')">QUIENES SOMOS</a></li>
                            <li class="active" routerLinkActive="active"><a class="inner-link"
                                    (click)="goTo('/')">SERVICIOS</a></li>
                            <li><a class="inner-link" (click)="goTo('/')">TRABAJOS REALIZADOS</a></li>
                            <li><a class="inner-link" (click)="goTo('/')">TESTIMONIOS</a></li>
                            <li><a class="inner-link" (click)="goTo('/')">CONTACTO</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </nav>
    <!-- end nav -->
</header>



<section class="bg-gray  padding-60px-tb xs-padding-60px-bottom  header-margin-top" style="min-height: 500px;">
    <div class="container">
        <div class="row  wow fadeInUp" data-wow-duration="0.4s"
            style="visibility: visible; animation-duration: 0.4s; animation-name: fadeInUp;">

            <div class="col-lg-12 col-md-12 col-sm-12 col-12 display-table text-center xs-text-left">
                <div class="display-table-cell-vertical-middle vertical-align-middle breadcrumb text-small alt-font">
                    <ul class="xs-text-center text-uppercase">
                        <li><a class="text-servios font-weight-600" href="javascript:void(0);"
                                (click)="goTo('/')">INICIO</a></li>
                        <li><span class="text-servios">SERVICIOS</span></li>
                        <li class="text-servios">{{servicio.nombre}}</li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="row">
            <div
                class="col-lg-8 col-md-8 col-sm-12 col-12 center-col margin-bottom-40px sm-margin-40px-bottom xs-margin-bottom-30px text-center last-paragraph-no-margin">
                <h2 class="alt-font font-weight-700 text-uppercase margin-bottom-20px">{{servicio.nombre}}</h2>
                <p class="no-margin-bottom wow fadeInUp">
                    {{servicio.descripcionLarga}}
                </p>
            </div>
        </div>

        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-10 col-md-10 col-sm-10 col-10">
                    <div class="work-3col wide gutter">
                        <div class="overflow-hidden grid-gallery">
                            <div class="tab-content">
                                <ul class="masonry-items grid work-gallery grid">

                                    <li class="html jquery xs-no-padding  wow fadeInUp"
                                        *ngFor="let item of servicio.imagenes">
                                        <figure>
                                            <div class="gallery-img lightbox-gallery">
                                                <a [href]="item" title=""><img [src]="item" alt=""></a>
                                            </div>
                                        </figure>
                                    </li>



                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="container-fluid" *ngIf="servicio.id === 9">
                        <h2 class=" section-title-large sm-section-title-medium xs-section-title-large text-servios
                        font-weight-700 alt-font margin-three-bottom xs-margin-fifteen-bottom">
                            El antes y el después</h2>
                        <div class="row four-column">

                            <!-- feature box -->
                            <div class="col-md-4 col-sm-6 col-xs-12 xs-no-margin-top bg-red-rgba  wow  fadeInLeft animated"
                                style="visibility: visible; animation-name: fadeInLeft;">
                                <div
                                    class="margin-seven-bottom xs-margin-five-bottom title-extra-large-4 alt-font text-white font-weight-500">
                                    01.</div>
                                <!-- <h3 class="text-white text-extra-large alt-font display-block">Terms and Data privacy</h3>
                                <p class="text-medium text-white">Strict NDA terms to ensure confidentiality and data protection and
                                    business privacy.</p>
                                <div class="separator-line2 bg-white margin-twenty-top"></div> -->
                                <img src="assets/image/galeria/servicioscasa/1.jpg" />
                            </div>
                            <!-- end feature box -->
                            <!-- feature box -->
                            <div class="col-md-4 col-sm-6 col-xs-12 xs-no-margin-top bg-black-medium-rgba  wow  fadeInLeft animated"
                                style="visibility: visible; animation-name: fadeInLeft;">
                                <div
                                    class="margin-seven-bottom xs-margin-five-bottom title-extra-large-4 alt-font text-white font-weight-500">
                                    02.</div>
                                <!-- <h3 class="text-white text-extra-large alt-font display-block">Tools and Technologies</h3>
                                <p class="text-medium text-white">Use of latest tools and technologies for every static and dynamic business
                                    need.</p>
                                <div class="separator-line2 bg-white margin-twenty-top"></div> -->
                                <img src="assets/image/galeria/servicioscasa/2.jpg" />

                            </div>
                            <!-- end feature box -->
                            <!-- feature box -->
                            <div class="col-md-4 col-sm-6 col-xs-12  xs-no-margin-top bg-dark-poison  wow  fadeInRight animated"
                                style="visibility: visible; animation-name: fadeInRight;">
                                <div
                                    class="margin-seven-bottom xs-margin-five-bottom title-extra-large-4 alt-font text-white font-weight-500">
                                    03.</div>
                                <!-- <h3 class="text-white text-extra-large alt-font display-block">Tools and Technologies</h3>
                                <p class="text-medium text-white">Use of latest tools and technologies for every static and dynamic business
                                    need.</p>
                                <div class="separator-line2 bg-white margin-twenty-top"></div> -->
                                <img src="assets/image/galeria/servicioscasa/4.jpeg" />
                            </div>
                            <!-- end feature box -->
                            <!-- feature box -->

                            <!-- end feature box -->
                        </div>
                    </div>
                </div>


                <aside class="col-md-2 col-sm-2 col-2 pull-right">


                    <div class="margin-bottom-45px xs-margin-25px-bottom wow fadeInRight" data-wow-duration="0.6s">
                        <div
                            class="text-dark-gray margin-bottom-20px alt-font text-uppercase font-weight-600 text-large aside-title">
                            <span>Servicios</span></div>
                        <ul class="aside-style margin-bottom-50px text-medium position-relative">
                            <li *ngFor="let item of servicios">
                                <a [routerLink]="['/servicio', item.id]" (click)="servicio = item"> {{item.nombre}}</a>
                            </li>

                        </ul>
                    </div>

                </aside>
            </div>

        </div>

    </div>
</section>



<app-footer></app-footer>